function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import Command from './command';
/**
 * @module core/multicommand
 */

/**
 * A CKEditor command that aggregates other commands.
 *
 * This command is used to proxy multiple commands. The multi-command is enabled when
 * at least one of its registered child commands is enabled.
 * When executing a multi-command the first command that is enabled will be executed.
 *
 *		const multiCommand = new MultiCommand( editor );
 *
 *		const commandFoo = new Command( editor );
 *		const commandBar = new Command( editor );
 *
 *		// Register child commands.
 *		multiCommand.registerChildCommand( commandFoo );
 *		multiCommand.registerChildCommand( commandBar );
 *
 *		// Enable one of the commands.
 *		commandBar.isEnabled = true;
 *
 *		multiCommand.execute(); // Will execute commandBar.
 *
 * @extends module:core/command~Command
 */

var MultiCommand = /*#__PURE__*/function (_Command) {
  _inherits(MultiCommand, _Command);

  var _super = _createSuper(MultiCommand);

  /**
   * @inheritDoc
   */
  function MultiCommand(editor) {
    var _this;

    _classCallCheck(this, MultiCommand);

    _this = _super.call(this, editor);
    /**
     * Registered child commands.
     *
     * @type {Array.<module:core/command~Command>}
     * @private
     */

    _this._childCommands = [];
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MultiCommand, [{
    key: "refresh",
    value: function refresh() {// Override base command refresh(): the command's state is changed when one of child commands changes states.
    }
    /**
     * Executes the first of it registered child commands.
     *
     * @returns {*} The value returned by the {@link module:core/command~Command#execute `command.execute()`}.
     */

  }, {
    key: "execute",
    value: function execute() {
      var command = this._getFirstEnabledCommand();

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return command != null && command.execute(args);
    }
    /**
     * Registers a child command.
     *
     * @param {module:core/command~Command} command
     */

  }, {
    key: "registerChildCommand",
    value: function registerChildCommand(command) {
      var _this2 = this;

      this._childCommands.push(command); // Change multi command enabled state when one of registered commands changes state.


      command.on('change:isEnabled', function () {
        return _this2._checkEnabled();
      });

      this._checkEnabled();
    }
    /**
     * Checks if any of child commands is enabled.
     *
     * @private
     */

  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      this.isEnabled = !!this._getFirstEnabledCommand();
    }
    /**
     * Returns a first enabled command or undefined if none of them is enabled.
     *
     * @returns {module:core/command~Command|undefined}
     * @private
     */

  }, {
    key: "_getFirstEnabledCommand",
    value: function _getFirstEnabledCommand() {
      return this._childCommands.find(function (command) {
        return command.isEnabled;
      });
    }
  }]);

  return MultiCommand;
}(Command);

export { MultiCommand as default };